<template>
  <ion-row>
    <ion-col class="text-center">
      <ion-icon src="/assets/contact/close-account.svg" class="w-[80px] h-[80px] fadein-400 mb-2"></ion-icon>
    </ion-col>
  </ion-row>
</template>